<template>
    <Iframe :sessionId="sessionId"/>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import axios from 'axios';
import Iframe from "@/components/Iframe.vue";
export default {
    components: {Iframe},
    props: ['eventName'],
    name: 'MapSession',
    computed: {
        ...mapGetters([
            'id', 'token', 'logged', 'name',"checkIOS", "checkMobile","checkSafari", 'sessions', 'map_sessions', 'email_verified'
        ]),
        ...mapGetters({
            template_html_state: 'TemplateHTML/getHTMLTemplateLoaded'
        }),
        sessionId() {
            let id =  this.map_sessions.default;
            if (this.checkIOS &&  this.map_sessions.ios) {
                id =  this.map_sessions.ios;
            } else if ((this.checkIOS || this.checkMobile) &&  this.map_sessions['4gb']) {
                id =  this.map_sessions['4gb'];
            } else if ((this.checkSafari) &&  this.map_sessions.safari) {
                id =  this.map_sessions.safari;
            }
            return id;
        },
    },
    data() {
        return {
        }
    },
    methods: {
        ...mapActions(['update_current_session', 'LMS/update_lms']),
    },
    mounted() {
    },
    beforeDestroy() {
    },
}
</script>

<style scoped></style>